module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    ref: "personOverlay",
    staticClass: "node node-type-person",
    class: ("theme-" + _vm.theme)
  }, [(!_vm.isEmpty(_vm.node)) ? _c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid  person-header article-gutter",
    class: {
      'hasCover': (!_vm.showVideo && _vm.overlay)
    },
    style: (_vm.coverStyle)
  }, [(_vm.overlay) ? _c('div', {
    staticClass: "image-holder grayscale",
    style: (_vm.coverStyle)
  }) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 content-wrapper mx-auto"
  }, [_c('div', {
    staticClass: "person-top"
  }, [(_vm.overlay && _vm.node.related_video && _vm.showingOverlay) ? _c('div', {
    ref: "cardVideoContainer",
    staticClass: "card-video-container"
  }, [_c('card-video', {
    attrs: {
      "nid": _vm.nid,
      "autoStart": false,
      "showCusPlayButton": true,
      "theme": "mobile",
      "isOverlay": _vm.overlay
    }
  })], 1) : _vm._e(), (!_vm.overlay && _vm.sections.length) ? _c('field-section', {
    staticClass: "node-label",
    attrs: {
      "sections": _vm.sections
    }
  }) : _vm._e(), _c('h1', {
    staticClass: "person-name"
  }, [_c('span', [_vm._v("Who Is ")]), _vm._v(_vm._s(_vm.node.title))]), (_vm.node.subheading) ? _c('div', {
    staticClass: "person-brief",
    domProps: {
      "innerHTML": _vm._s(_vm.node.subheading)
    }
  }, [_vm._v(_vm._s(_vm.node.subheading))]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "container-fluid content-wrapper inner-content article-gutter"
  }, [(!_vm.overlay) ? _c('field-date', {
    staticClass: "field-date",
    attrs: {
      "node": _vm.node
    }
  }) : _vm._e(), (!_vm.overlay) ? _c('share-pane', {
    staticClass: "share-pane",
    attrs: {
      "node": _vm.node
    }
  }) : _vm._e(), _c('field-body', {
    ref: "articleBody",
    attrs: {
      "body": _vm.node.body,
      "node": _vm.node,
      "bodyOptions": _vm.bodyOptions
    }
  })], 1), _c('div', {
    staticClass: "container-fluid timeline-wrapper"
  }, [(_vm.isEmptyTimeline) ? _c('timeline', {
    staticClass: "no-article-swipe row",
    attrs: {
      "nid": _vm.nid,
      "isOverlay": _vm.overlay
    }
  }) : _vm._e()], 1), (!_vm.overlay) ? _c('div', {
    staticClass: "container-fluid panes-wrapper hidden-sm-down"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.desktopGridLayout), function(group, index) {
    return _c('div', {
      staticClass: "col-sm-4 pane-column"
    }, [_vm._l((group), function(item, index) {
      return [(item.type === 'property') ? _c('property-pane', {
        staticClass: "property-pane article-gutter pane",
        attrs: {
          "property": item.data
        }
      }) : (item.type === 'history') ? _c('div', {
        staticClass: "career-history-pane article-gutter pane"
      }, [_c('h3', {
        staticClass: "career-history-title"
      }, [_vm._v("career history")]), _c('ul', {
        staticClass: "pane-list"
      }, _vm._l((item.data), function(career, key) {
        return _c('li', {
          key: key
        }, [_vm._v(_vm._s(career))])
      }))]) : (item.type === 'awards') ? _c('div', {
        staticClass: "awards-publication-pane  article-gutter pane"
      }, [_c('h3', {
        staticClass: "awards-publication-title"
      }, [_vm._v("awards & publication")]), (!_vm.isEmpty(item.data.awards)) ? _c('div', {
        staticClass: "attr-label-tag"
      }, [_vm._v("awards")]) : _vm._e(), _c('ul', {
        staticClass: "pane-list"
      }, _vm._l((item.data.awards), function(award, key) {
        return _c('li', {
          key: key
        }, [_vm._v(_vm._s(award))])
      })), (!_vm.isEmpty(item.data.publications)) ? _c('div', {
        staticClass: "attr-label-tag"
      }, [_vm._v("publications")]) : _vm._e(), _c('ul', {
        staticClass: "pane-list"
      }, _vm._l((item.data.publications), function(publication, key) {
        return _c('li', {
          key: key
        }, [_vm._v(_vm._s(publication))])
      }))]) : (item.type === 'quote') ? _c('div', {
        staticClass: "quotes-pane pane article-gutter col-12"
      }, [_c('transition-group', {
        attrs: {
          "name": "list",
          "tag": "div"
        }
      }, _vm._l((_vm.node.quotes), function(quote, index) {
        return (index === 0 || _vm.showQuotes) ? _c('quote-block', {
          key: index,
          staticClass: "quote-block",
          attrs: {
            "value": quote
          }
        }) : _vm._e()
      })), (!_vm.showQuotes && _vm.node.quotes.length > 1) ? _c('div', {
        staticClass: "load-more-button",
        on: {
          "click": function($event) {
            _vm.showQuotes = true
          }
        }
      }, [_vm._v("show more quotes(" + _vm._s(_vm.node.quotes.length - 1) + ")")]) : _vm._e()], 1) : (item.type === 'relatedArticles') ? _c('div', {
        staticClass: "related-articles-pane article-gutter pane"
      }, [_c('h3', [_vm._v("related articles")]), _c('transition-group', {
        attrs: {
          "name": "list",
          "tag": "div"
        }
      }, _vm._l((_vm.relatedArticles), function(nid, index) {
        return _c('article-level-one', {
          key: index,
          staticClass: "article-level-one",
          class: {
            first: index === 0, last: index === _vm.relatedArticles.length - 1
          },
          attrs: {
            "nid": nid
          }
        })
      })), (_vm.loading) ? _c('loader') : (!_vm.noMoreContent) ? _c('div', {
        staticClass: "load-more-button",
        on: {
          "click": _vm.loadMoreRelatedArticles
        }
      }, [_vm._v("show more articles")]) : _vm._e()], 1) : (item.type === 'tag') ? _c('div', {
        staticClass: "tags-wrapper  article-gutter pane"
      }, [_c('tag', {
        attrs: {
          "node": _vm.node
        }
      })], 1) : (item.type === 'slideshow') ? _c('article-gallery', {
        staticClass: "gallery-pane",
        attrs: {
          "nid": _vm.nid,
          "theme": "mobile"
        }
      }) : (item.type === 'random-people') ? _c('div', {
        staticClass: "pane article-gutter random-people-pane"
      }, [_c('h3', [_vm._v(_vm._s(_vm.lastSection.title))]), _vm._l((_vm.randomPeople), function(person, index) {
        return _c('div', [_c('node-link', {
          staticClass: "random-person",
          attrs: {
            "url": person.relative_url,
            "type": person.type,
            "nid": person.nid,
            "title": person.title
          }
        }, [_vm._v(_vm._s(person.title))])], 1)
      })], 2) : _vm._e()]
    })], 2)
  }))]) : _vm._e(), _c('div', {
    staticClass: "container-fluid  article-gutter panes-wrapper",
    class: [{
      'hidden-sm-up': !_vm.overlay
    }, {
      overlay: _vm.overlay
    }]
  }, [_c('div', {
    staticClass: "row no-article-gutter"
  }, [_vm._l((_vm.node.properties), function(property, key, index) {
    return [(!_vm.isEmpty(property)) ? _c('property-pane', {
      key: key,
      staticClass: "property-pane article-gutter pane col-12",
      attrs: {
        "property": property
      }
    }) : _vm._e(), (index === 0 && !_vm.isEmpty(_vm.node.history)) ? _c('div', {
      staticClass: "career-history-pane article-gutter pane col-12"
    }, [_c('h3', {
      staticClass: "career-history-title"
    }, [_vm._v("career history")]), _c('ul', {
      staticClass: "pane-list"
    }, _vm._l((_vm.node.history), function(career, key) {
      return _c('li', {
        key: key
      }, [_vm._v(_vm._s(career))])
    }))]) : _vm._e()]
  }), (_vm.node.awards || _vm.node.publication) ? _c('div', {
    staticClass: "awards-publication-pane  article-gutter pane col-12"
  }, [_c('h3', {
    staticClass: "awards-publication-title"
  }, [_vm._v("awards & publication")]), (!_vm.isEmpty(_vm.node.awards)) ? _c('div', {
    staticClass: "attr-label-tag"
  }, [_vm._v("awards")]) : _vm._e(), _c('ul', {
    staticClass: "pane-list"
  }, _vm._l((_vm.node.awards), function(award, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(award))])
  })), (!_vm.isEmpty(_vm.node.publications)) ? _c('div', {
    staticClass: "attr-label-tag"
  }, [_vm._v("publications")]) : _vm._e(), _c('ul', {
    staticClass: "pane-list"
  }, _vm._l((_vm.node.publications), function(publication, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(publication))])
  }))]) : _vm._e(), (_vm.node.quotes) ? _c('div', {
    staticClass: "quotes-pane pane article-gutter col-12"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.node.quotes), function(quote, index) {
    return (index === 0 || _vm.showQuotes) ? _c('quote-block', {
      key: index,
      staticClass: "quote-block",
      attrs: {
        "value": quote
      }
    }) : _vm._e()
  })), (!_vm.showQuotes && _vm.node.quotes.length > 1) ? _c('div', {
    staticClass: "load-more-button",
    on: {
      "click": function($event) {
        _vm.showQuotes = true
      }
    }
  }, [_vm._v("show more quotes(" + _vm._s(_vm.node.quotes.length - 1) + ")")]) : _vm._e()], 1) : _vm._e(), (!_vm.isEmpty(_vm.relatedArticles)) ? _c('div', {
    staticClass: "related-articles-pane article-gutter pane col-12"
  }, [_c('h3', [_vm._v("related articles")]), _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.relatedArticles), function(nid, index) {
    return _c('article-level-one', {
      key: index,
      staticClass: "article-level-one",
      class: {
        first: index === 0, last: index === _vm.relatedArticles.length - 1
      },
      attrs: {
        "nid": nid
      }
    })
  })), (_vm.loading) ? _c('loader') : (!_vm.noMoreContent) ? _c('div', {
    staticClass: "load-more-button",
    on: {
      "click": _vm.loadMoreRelatedArticles
    }
  }, [_vm._v("show more articles")]) : _vm._e()], 1) : _vm._e(), _c('article-gallery', {
    staticClass: "gallery-pane",
    attrs: {
      "nid": _vm.nid,
      "theme": "mobile"
    }
  }), _c('div', {
    staticClass: "tags-wrapper article-gutter pane col-12"
  }, [_c('tag', {
    attrs: {
      "node": _vm.node
    }
  })], 1), (!_vm.isEmpty(_vm.randomPeople)) ? _c('div', {
    staticClass: "pane article-gutter random-people-pane col-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.lastSection.title))]), _vm._l((_vm.randomPeople), function(person, index) {
    return _c('div', [_c('node-link', {
      staticClass: "random-person",
      attrs: {
        "url": person.relative_url,
        "type": person.type,
        "nid": person.nid,
        "title": person.title
      }
    }, [_vm._v(_vm._s(person.title))])], 1)
  })], 2) : _vm._e()], 2)])]) : _c('loader', {
    staticClass: "loader"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6d8d51e","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/person/PersonBody.vue
// module id = 1777
// module chunks = 1